/*
 * @Date: 2021-08-19 17:20:32
 * @LastEditTime: 2025-11-27 22:35:26
 * @Description:
 */
import { request } from 'api/http-youke-activity';
import { UrlLinkData, IAccountInfo, Iupload, IsSubscribedData } from './index.i';
const Api_common = {
  /** token换取用户信息 */
  base_account_info(params: { token: string }) {
    return request.get<any>(`/platform/api/account/base_account_info`, { params });
  },
  /**获取会员信息
   * @link https://gitlab.weike.fm/oc/oc-docs/blob/master/operating/会员体系/接口文档/获取会员信息.md#1-获取会员信息
   */
  account_info() {
    return request.get<IAccountInfo.Data>(`/membership/api/membership/account_info`);
  },
  /**
   * 获取跳转小程序的短链
   * @param link https://gitlab.weike.fm/oc/oc-docs/-/blob/yyl/operating/dispatch/小程序路由链接接口.md#2-获取小程序链接
   * @param tag  scheme / link
   * @link  测试环境Django后台 https://dbg.lizhiweike.com/oc_operating/admin/dispatch/xcxsetting/
   * @link  线上环境Django后台 https://m.lizhiweike.com/oc_operating/admin/dispatch/xcxsetting/
   * @param name Django后台配置对应的appID和secrect
   */
  xcx_path(params: { tag: 'scheme' | 'link'; name: string; data: any }) {
    // 有课小程序已下线，/oc_operating/api/dispatch/xcx_path/ 已随 operating 下架，跳转不再执行（占位保留函数签名）
    return new Promise<any>(() => {});
  },
  /** 上传图片 */
  content_upload(params: { file_data: any; file_type: string; file_name: string }) {
    return request.upload<Iupload.Data>(`/operating_admin/content_upload`, params);
  },
  // 是否关注公众号
  is_subscribed(params: { group_name?: string }) {
    return request.get<IsSubscribedData>('/operating/api/is_subscribed', { params });
  },
  // 获取&更新域名
  get_domain_status(params: { cipher_text: string; status?: number; operator?: string }) {
    return request.notTokenGet<any>(`https://gw.lizhiweike.com/__wk_redirect/wk_redirect/outer/domain.status.get_or_update`, { params });
  },
  // 获取域名列表
  get_domain_active() {
    return request.notTokenGet<any>(`https://gw.lizhiweike.com/__wk_redirect/wk_redirect/outer/domain.active.get`, {});
  },
};

export default Api_common;
